import {init,globalHandlersIntegration,browserApiErrorsIntegration,dedupeIntegration,eventFiltersIntegration} from '@sentry/browser';
import {browserDSN,environmentForHost,privacyOptions} from './sentry-policy.js';

const environment=environmentForHost(location.hostname);
if(environment&&!location.pathname.startsWith('/research/')){
 init({
  ...privacyOptions,dsn:browserDSN,environment,release:__WFG_RELEASE__,
  defaultIntegrations:false,
  integrations:[globalHandlersIntegration(),browserApiErrorsIntegration(),dedupeIntegration(),eventFiltersIntegration()],
  // Do not report extension or third-party script failures.
  allowUrls:[/^https:\/\/(?:www\.)?wefundgood\.org\//,/^https:\/\/wfg-website\.matt-464\.workers\.dev\//],
 });
}
